import client from '../utils/client';
import { contactsUrl, branchRequestsUrl, jobsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const formService = {
  contactsList,
  getContact,
  branchRequestsList,
  getBranchRequest,
  jobsList,
  getJob
}

function contactsList(pageID, perPage, searchInput) {
  let searchQuery = '';
  if(searchInput !== '') {
    searchQuery = '&s=' + searchInput;
  }
  return client.get(contactsUrl + '?page=' + pageID + '&per_page=' + perPage + searchQuery)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getContact(contactID) {
  return client.get(contactsUrl + '/' + contactID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function branchRequestsList(pageID, perPage, searchInput) {
  let searchQuery = '';
  if(searchInput !== '') {
    searchQuery = '&s=' + searchInput;
  }
  return client.get(branchRequestsUrl + '?page=' + pageID + '&per_page=' + perPage + searchQuery)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getBranchRequest(branchRequestID) {
  return client.get(branchRequestsUrl + '/' + branchRequestID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function jobsList(pageID, perPage, searchInput) {
  let searchQuery = '';
  if(searchInput !== '') {
    searchQuery = '&s=' + searchInput;
  }
  return client.get(jobsUrl + '?page=' + pageID + '&per_page=' + perPage + searchQuery)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getJob(jobID) {
  return client.get(jobsUrl + '/' + jobID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}